import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { getImagesForLeg } from '../../actions/images';
import { useCurrentLegCrew } from '../../selectors/screen';
import { EmployersList } from './EmployersList/EmployersList';
import { useStyles } from './useStyles';

export const EmployersPage = memo(() => {
    const dispatch = useDispatch();
    const crew = useCurrentLegCrew();
    const classes = useStyles();
    const { t: translate } = useTranslation();
    React.useEffect(() => {
        if (crew) {
            dispatch(getImagesForLeg(crew));
        }
    }, [crew]);

    const { cabinList, flightAttendantList, otherList } = React.useMemo(() => {
        const crewList = Object.values(crew || {});
        const cabinList = crewList.filter((emp) => emp.crewType === 0);
        const flightAttendantList = crewList.filter((emp) => emp.crewType === 1);
        const otherList = crewList.filter((emp) => emp.crewType >= 2);

        return {
            cabinList,
            flightAttendantList,
            otherList,
        };
    }, [crew]);

    return (
        <ErrorBoundary>
            <div className={classes.crewWrapper}>
                <EmployersList title={translate('labels.flightCrew')} data={cabinList} />
                <EmployersList title={translate('labels.flightAttendants')} data={flightAttendantList} />
                <EmployersList title={translate('labels.other')} data={otherList} />
            </div>
        </ErrorBoundary>
    );
});
